import React from "react";
import "./RefreshButton.scss";

import BigLabel from "../BigLabel/BigLabel";

const RefreshButton = ({ children, onClick }) => {
  return (
    <div className="refresh-button">
      <BigLabel onClick={onClick}>{children}</BigLabel>
    </div>
  );
};

export default RefreshButton;
